import React from "react";
import { Typography, FormControl, Select, MenuItem, Box } from "@mui/material";

const getCurrentDateContext = () => {
  const now = new Date();

  return {
    currentYear: now.getFullYear(),
    currentMonthNumber: now.getMonth() + 1,
  };
};

function FilterContainer(props) {
  const {
    elements,
    config,
    setValues,
    values,
    currentDash,
    initialValue,
    filters,
    filter,
    handleFilterChange,
    index,
    label,
  } = props;

  const normalizedLabel = String(label || "").toLowerCase();
  const sourceElements =
    normalizedLabel === "region" && Array.isArray(filter?.elements) ? filter.elements : elements;

  const getMonthElements = () => {
    if (label !== "Month") return sourceElements;

    const { currentYear, currentMonthNumber } = getCurrentDateContext();
    const selectedYear = Number(values?.Year ?? filters?.Year?.value);

    if (selectedYear !== currentYear) return sourceElements;

    return sourceElements.filter((element) => Number(element?.id_int || 0) <= currentMonthNumber);
  };

  const renderedElements = getMonthElements();
  const selectedValueStillVisible = renderedElements.some((element) => element.id === (initialValue ?? ""));
  const selectedValue = selectedValueStillVisible ? initialValue ?? "" : renderedElements[renderedElements.length - 1]?.id || "";
  const selectedElementLabel = renderedElements.find((element) => element.id === selectedValue)?.label || "";

  function handleChange(event, filterElement, index, filter) {
    switch (filter.action) {
      case "prompt":
        {
          const nextValue = filterElement.props.value;
          const { currentYear, currentMonthNumber } = getCurrentDateContext();
          const updatedFilters = {
            ...filters,
            [filter.label]: { ...filter, value: nextValue },
          };
          const updatedValues = { ...values, [label]: nextValue };

          if (label === "Year" && updatedFilters.Month) {
            const monthFilter = { ...updatedFilters.Month };
            const monthElements = monthFilter.displayedElements || monthFilter.elements || [];

            if (Number(nextValue) === currentYear) {
              const allowedMonths = monthElements.filter(
                (element) => Number(element?.id_int || 0) <= currentMonthNumber,
              );
              const currentMonthIsValid = allowedMonths.some((element) => element.id === monthFilter.value);

              if (!currentMonthIsValid) {
                const fallbackMonth = allowedMonths[allowedMonths.length - 1];

                monthFilter.value = fallbackMonth?.id || "";
                updatedValues.Month = monthFilter.value;
              }
            }

            updatedFilters.Month = monthFilter;
          }

          setValues(updatedValues);
          handleFilterChange(updatedFilters);
        }
        break;
      case "link":
        setValues({ ...values, [label]: filterElement.props.value });
        filter.value = filterElement.props.value;
        const links = filter.elements.find((t) => t.id == filterElement.props.value).links;

        window.open(config.backendServiceURL + links[currentDash], "_blank");
        break;
    }
  }

  return (
    <Box sx={{ width: { xs: "92px", sm: "102px" }, minWidth: { xs: "92px", sm: "102px" } }}>
      <Typography
        sx={{
          color: "white",
          fontSize: "0.82rem",
          lineHeight: 1,
          marginBottom: "2px",
          marginLeft: "6px",
        }}
      >
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select
          key={label}
          disabled={elements.length == 0}
          displayEmpty
          id="mstr-filter-select"
          index={index}
          sx={{
            color: "white",
            height: "28px",
            fontSize: "1rem",
            "& .MuiSelect-select": {
              paddingTop: "2px",
              paddingBottom: "2px",
              paddingLeft: "8px",
              minHeight: "auto !important",
              display: "flex",
              alignItems: "center",
            },
          }}
          value={selectedValue}
          renderValue={() => selectedElementLabel}
          onChange={(x, i) => handleChange(x, i, index, filter)}
        >
          {renderedElements.map((element) => (
            <MenuItem key={element.id} value={element.id}>
              {element.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default FilterContainer;
